export default {
  Menu: {
    account: 'Conta',
    alterar_conta: 'Alterar Conta',
    trocar_senha: 'Alterar Senha',
    gerenciar_usuarios: 'Gerenciar Usuários',
    indique_ganhe: 'Indique e ganhe',
    about_the_user: 'Seu usuário',
    alterar_idioma: 'Alterar Idioma',
    config_area: 'Configurar área',
    users: 'Usuários',
    edit_user: 'Editar usuário',

    PasswordModal: {
      type_here: 'Digite aqui',
      current_password: 'Senha atual',
      new_password: 'Nova senha',
      confirm_password: 'Confirme a senha',
    },
  },
}
